import { menuData } from './menu.model'; // Menu靜態設定檔

export const menuJson = [
  ...menuData
];
